// extracted by mini-css-extract-plugin
export default {"root":"YpT8KM","ShinyMenuIIButtonNSkin":"h2voH4","shinyMenuIiButtonNSkin":"h2voH4","linkElement":"_95kmcq","extra":"FTKYyL","wrapper":"Qz5ULw","label":"ObnQc8"};